import axios from 'axios';

const DEEPSEEK_API_KEY = process.env.REACT_APP_DEEPSEEK_API_KEY;
const DEEPSEEK_API_URL = process.env.REACT_APP_DEEPSEEK_API_URL || 'https://api.deepseek.com/v1/chat/completions';

/**
 * Service to interact with the Deepseek API
 */
const deepseekService = {
  /**
   * Get AI-generated answer for a Scrum-related question
   * @param {string} question - The user's question
   * @returns {Promise<string>} - The AI-generated answer
   */
  getAnswer: async (question) => {
    try {
      const response = await axios.post(
        DEEPSEEK_API_URL,
        {
          model: 'deepseek-chat',
          messages: [
            {
              role: 'system',
              content: 'You are a Scrum expert assistant. CRITICAL: You MUST respond in ENGLISH ONLY. Never use Chinese, Japanese, Korean, or any non-English language. Provide helpful, concise, and practical English advice for Scrum-related questions. Include specific examples and actionable steps when possible. All explanations, examples, and terminology should be in English.'
            },
            {
              role: 'user',
              content: question
            }
          ],
          temperature: 0.7,
          max_tokens: 500
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${DEEPSEEK_API_KEY}`
          }
        }
      );
      
      return response.data.choices[0].message.content;
    } catch (error) {
      console.error('Error calling Deepseek API:', error);
      throw new Error('Failed to get answer from AI. Please try again later.');
    }
  }
};

export default deepseekService;